import React from 'react'
import styled from 'styled-components'
import {Button, Card, CardBody, Heading, Text} from '@eggplant-finance/eggplant-uikit-theme'
import useI18n from 'hooks/useI18n'
// import { useGetStats } from 'hooks/api'
import {useTotalValue} from '../../../state/hooks'
import CardValue from './CardValue'
import UnlockButton from "../../../components/UnlockButton";

const StyledTotalValueLockedCard = styled(Card)`
  min-height: 176px;
  align-items: center;
  display: flex;
  flex: 1;
`

const StyledCardBody = styled(CardBody)`
  width: 30vw;
`

const InnerCardAlign = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const ModiHeader = styled(Heading)`
  color: ${({theme})=> theme.isDark ? '#e8e2fb' : '#460a80'}
`;

const ModiText = styled(Text)`
  color: ${({theme})=> theme.isDark ? ' #8e81b8' : '#000'}
`

const TransparentTotalValueLockedCard = () => {
    const TranslateString = useI18n()
    // const data = useGetStats()
    const totalValue = useTotalValue()
    // const tvl = totalValue.toFixed(2);

    return (
        <StyledCardBody>
            <InnerCardAlign>
                <ModiHeader size="xl" mb="24px">
                    {TranslateString(997, 'Total Value Locked (TVL)')}
                </ModiHeader>
                <>
                    {/* <Heading size="xl">{`$${tvl}`}</Heading> */}
                    {/* <Heading size="xl"> */}
                    <ModiText color="textSubtle" bold>{TranslateString(1005, 'Across all Farms and Pools')}</ModiText>
                    <CardValue value={totalValue.toNumber()} prefix="$" decimals={2}/>
                    {/* </Heading> */}
                </>
            </InnerCardAlign>
        </StyledCardBody>
    )
}

export default TransparentTotalValueLockedCard
